import { ENTRY_DATA_CLINICAL_TRIAL_DESIGN } from "@frontend/common";

import type { ClinicalTrialsSection } from "@/types/clinicalTrials.types";

export const CHECK_TABLE_KEY_BY_GROUP_TABLE_KEY: {
  "Clinical Trials": {
    [key in ClinicalTrialsSection]: string | null;
  };
} = {
  "Clinical Trials": {
    "Drug Profile": "Drug",
    "Clinical Endpoints (Table)": "Data",
    [ENTRY_DATA_CLINICAL_TRIAL_DESIGN]: null,
    "Clinical Results": null,
    "Clinical Endpoints (Description)": null,
    "Key Comment": null,
  },
};
